import { render, staticRenderFns } from "./Modal_AFAS_3_Locations.vue?vue&type=template&id=70e2a9e7&scoped=true&"
import script from "./Modal_AFAS_3_Locations.vue?vue&type=script&lang=js&"
export * from "./Modal_AFAS_3_Locations.vue?vue&type=script&lang=js&"
import style0 from "./Modal_AFAS_3_Locations.vue?vue&type=style&index=0&id=70e2a9e7&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70e2a9e7",
  null
  
)

export default component.exports